import ereceiptCode from './ereceiptFilters';

export default {
    install(Vue) {
        Vue.filter('ereceiptCode', ereceiptCode);
    }
}